import * as tslib_1 from "tslib";
import { BaseComponent } from "../../../../base/base.component";
import { AppComponent } from "../../../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { GenericService } from "../../../../../crossconcern/services/generic.services";
import { AlertUtils } from "../../../../../crossconcern/utilities/utils/alert.utils";
import { FormInfoField } from "../../../../../crossconcern/models/form/forminfofield";
import { ADD_MODE, FORM_TYPE_CHECKBOX, FORM_TYPE_TEXT, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0 } from "../../../../../crossconcern/utilities/properties/base.property";
import { Validators } from "@angular/forms";
import { FormInfo } from "../../../../../crossconcern/models/form/forminfo";
import { PRIVATE_NURSERY_LIST_ROUTE } from "../../../../../crossconcern/utilities/properties/routename.property";
import { finalize } from "rxjs/operators";
import { NurseryManager } from "app/business/managers/nursery.manager";
var NurseryNewComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NurseryNewComponent, _super);
    function NurseryNewComponent(appComponent, router, location, genericService, nurseryManager, activeRoute, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.genericService = genericService;
        _this.nurseryManager = nurseryManager;
        _this.activeRoute = activeRoute;
        _this.alertUtils = alertUtils;
        _this.selectedFiles = [];
        _this.titleText = "NURSERY_NEW_COMPONENT_LABEL";
        _this.imageURL = null;
        _this.mode = ADD_MODE;
        _this.dropdownSettings = {
            singleSelection: false,
            idField: "id",
            textField: "text",
            enableCheckAll: false,
            allowSearchFilter: true
        };
        var formInfoFields = [
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_NAME", "name", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_ADDRESS", "address", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_LAT", "latitude", [
                Validators.required,
                Validators.pattern("[0-9]+([.][0-9]+)?")
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_LONG", "longitude", [
                Validators.required,
                Validators.pattern("[0-9]+([.][0-9]+)?")
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_VERSION_NUMBER", "versionNumber", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_CHECKBOX, "NURSERY_DETAIL_COMPONENT_VISIBLE", "visible", [], null, null, true, true, false, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0)
        ];
        _this.formInfo = new FormInfo(formInfoFields, null);
        _this.subscribeGenericServices();
        return _this;
    }
    NurseryNewComponent.prototype.ngOnInit = function () {
        /*
        nothing
        */
    };
    NurseryNewComponent.prototype.onFilesSelected = function (event) {
        this.selectedFiles = event;
    };
    NurseryNewComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeServices();
    };
    NurseryNewComponent.prototype.onSaveNursery = function () {
        var _this = this;
        this.appComponent.startLoading();
        this.nurseryManager.addNursery({
            "name": this.formComponent.form.value.name,
            "address": this.formComponent.form.value.address,
            "latitude": this.formComponent.form.value.latitude,
            "longitude": this.formComponent.form.value.longitude,
            "visible": (this.formComponent.form.value.visible === null) ? false : this.formComponent.form.value.visible,
            "version_number": this.formComponent.form.value.versionNumber
        })
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe({
            complete: function () { return _this.goToRouteByName(PRIVATE_NURSERY_LIST_ROUTE); }
        });
    };
    NurseryNewComponent.prototype.subscribeGenericServices = function () {
        var _this = this;
        this.onGoBackCalledSubscription = this.genericService.onGoBackCalled.subscribe(function () {
            _this.goToRouteByName(PRIVATE_NURSERY_LIST_ROUTE);
        });
    };
    NurseryNewComponent.prototype.unsubscribeServices = function () {
        if (this.onGoBackCalledSubscription) {
            this.onGoBackCalledSubscription.unsubscribe();
        }
    };
    return NurseryNewComponent;
}(BaseComponent));
export { NurseryNewComponent };
